import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    title: String,
    text: String,
  }

  connect() {
    if (navigator.share) {
      this.element.classList.remove('d-none')
    }
  }

  share() {
    navigator.share({
      title: this.titleValue,
      text: this.textValue,
    })
  }
}
